import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TeacherSidebar from '../components/TeacherSidebar';
import { LogOut } from 'lucide-react';

// Pages
import TeacherHome from './teacher/TeacherHome';
import TeacherGroups from './teacher/TeacherGroups';
import TeacherGroupStudents from './teacher/TeacherGroupStudents';
import TeacherSubjects from './teacher/TeacherSubjects';
import TeacherMaterials from './teacher/TeacherMaterials';
import TeacherProfile from './teacher/TeacherProfile';

const TeacherDashboard = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || '?';
  };

  return (
    <div className="dashboard-layout">
      <TeacherSidebar />
      
      <main className="main-content">
        <header className="main-header">
          <div className="page-title">
            <h1>Buxoro Xalqaro Tibbiyot Texnikumi</h1>
            <p>O'qituvchi paneli</p>
          </div>
          
          <div className="user-menu">
            <div className="user-info">
              <div className="name">{user?.first_name} {user?.last_name}</div>
              <div className="role">{user?.role_display}</div>
            </div>
            <div className="user-avatar teacher">
              {getInitials(user?.first_name, user?.last_name)}
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <LogOut size={18} />
              Chiqish
            </button>
          </div>
        </header>

        <div className="page-content">
          <Routes>
            <Route path="/" element={<TeacherHome />} />
            <Route path="/groups" element={<TeacherGroups />} />
            <Route path="/groups/:groupId/students" element={<TeacherGroupStudents />} />
            <Route path="/subjects" element={<TeacherSubjects />} />
            <Route path="/materials" element={<TeacherMaterials />} />
            <Route path="/profile" element={<TeacherProfile />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default TeacherDashboard;
